import type {SlotGameStore, BaseComponentConfig} from "@gamzix/slot_core";

class IntrigueBonusComponent extends Game.src.component.BaseComponent {
    protected mainGameContainerElement = null;
    protected tweens = [];

    constructor(config: BaseComponentConfig) {
        super(config);
    }

    onGameReady() {
        super.onGameReady();

        this.mainGameContainerElement = game.tree.findByName("intrigueBonus.wrapper_container.main_game_container");

        game.on('BonusReelsetComponent.REEL_BONUS_ANTICIPATION_STARTED', () => {
            this.showReelIntrigue();
        });

        game.on('BonusReelsetComponent.REEL_BONUS_ANTICIPATION_FINISH', () => {
            this.hideReelIntrigue();
        });
    }

    scaleGame(from, to, time) {
        const container = game.tree.findByName("bonus_game.number_reel_set.main.wrapper_container");
        this.removeTweens();

        let pFrom = 0;
        let pTo = 0;

        if (from == 1) {
            pFrom = 0;
            pTo = 130; /////
        } else {
            pFrom = container.position.x;
            pTo = 0;
        }

        const param = {from: pFrom, to: pTo, time: time};

        const promises = [
            game.utils.GameUtils.playScaleToAnimation(container, {scaleFrom: from, scaleTo: to, time: time}),
            game.utils.GameUtils.playScaleToAnimation(this.view, {scaleFrom: from, scaleTo: to, time: time}),
            this.playPositionXAnimation(container, param),
            this.playPositionXAnimation(this.view, param)
        ];

        //@ts-ignore
        this.tweens.push(container._tween, this.view._tween);

        return Promise.all(promises);
    };

    removeTweens() {
        this.tweens.forEach(tween => game.utils.removeCall(tween));
        this.tweens = [];
    }

    onChangeOrientation() {
        super.onChangeOrientation();
        const container = game.tree.findByName("spine_gm_bonus_royalchip");

        this.setPositionMainGlow();

        this.mainGameContainerElement.forceViewUpdate();
        //@ts-ignore
        this.view.forceViewUpdate();
        // this.onFinishIntrigue();
        container.forceViewUpdate();
    }

    onFinishIntrigue() {
        this.removeTweens();

        this.mainGameContainerElement.options.alpha = 0;
        this.mainGameContainerElement.forceViewUpdate();

        const container = game.tree.findByName("spine_gm_bonus_royalchip");

        container.options.scale = {x: 1, y: 1};
        container.options.position.x = 0;

        //@ts-ignore
        this.view.options.scale = {x: 1, y: 1};
        //@ts-ignore
        this.view.options.position.x = 0;
        //@ts-ignore
        this.view.forceViewUpdate();
        container.forceViewUpdate();
    }

    protected setPositionMainGlow() {
        this.mainGameContainerElement.options.position.x = game.tree.findByName("numbers_reel_0").position.x * this.mainGameContainerElement.options.scale.x;
    }

    showReelIntrigue() {
        this.showFlowMainGame();
        this.setPositionMainGlow();
        this.scaleGame(1, 1.2, 2000);
    }

    hideReelIntrigue() {
        this.hideFlowMainGame();
        this.onChangeOrientation();

        const container = game.tree.findByName("bonus_game.number_reel_set.main.wrapper_container");


        this.scaleGame(container.options.scale.x, 1, 200).then(() => {
            this.onFinishIntrigue();
        });
    }

    protected async showFlowMainGame() {
        await game.utils.GameUtils.playAlphaAnimation(this.mainGameContainerElement, {from: 0, to: 1, time: 300, timeWait: 0});
    }

    protected async hideFlowMainGame() {
        await game.utils.GameUtils.playAlphaAnimation(this.mainGameContainerElement, {from: 1, to: 0, time: 50, timeWait: 0});
    }

    async playAlphaAnimation(object, {from, to, time, timeWait}): Promise<void> {
        return new Promise((resolve) => {
            const _tw = {count: from};

            object.options.visible = true;
            object.options.alpha = from;

            const _tween = createjs.Tween.get(_tw, {
                onChange: () => {
                    object.options.alpha = _tw.count;
                    object.forceViewUpdate();
                }
            })
                .to({count: to}, time)
                .wait(timeWait || 0)
                .call(() => {
                    object.options.visible = Boolean(to);
                    resolve();
                });

            object._tween = _tween;
        });
    }

    async playPositionXAnimation(obj, {
        from, to, time, onStart = () => {
        }, onFinish = () => {
        }
    }) {
        return new Promise((resolve) => {
            const _tw = {current: from};

            const _tween = createjs.Tween.get(_tw, {
                onChange: () => {
                    obj.options.position.x = _tw.current;
                    obj.forceViewUpdate();
                }
            })
                .call(onStart.bind(this, obj))
                .to({current: to}, time)
                .call(onFinish.bind(this, obj))
                .call(resolve);

            obj._tween = _tween;
        });
    }


    get store(): SlotGameStore {
        return <SlotGameStore>game.store;
    }

}

export {IntrigueBonusComponent};

//@ts-ignore
Game.src.component.IntrigueBonusComponent = IntrigueBonusComponent;
